import { useMemo, useState } from 'react';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useDishMenuStore } from '../../../../../../../store/use-dish-menu-store';
import { useDishStore } from '../../../../../../../store/use-dish-store';
import { IdValue } from '../../../../../../../types/props';
import { useQueryParams } from '../../../../../../../hooks/use-query-params';
import { validate } from '../../../../../../../helpers/validate';
import { ModalProps } from '../../../../../../../components/modal/modal';

export const useMenuInformerCopyDishModal = (props: ModalProps) => {
  const { menuList, fetchMenu } = useDishMenuStore();
  const { isLoading, copyDish } = useDishStore();

  const { t, getLocale } = useLang();

  const [menu, setMenu] = useState<IdValue>();
  const [section, setSection] = useState<IdValue>();
  const [category, setCategory] = useState<IdValue>();

  const params = useQueryParams().getQueryParams();
  const dishId = params.dishId;
  const currentMenu = params.menuId;

  const { menus, sections, categories } = useMemo(() => {
    const menus = menuList?.filter((item) => item.id !== currentMenu);

    const sections: IdValue[] =
      menus
        ?.find((item) => String(item.id) === menu?.id)
        ?.sections?.map((item) => ({ id: String(item.id), value: getLocale(item.name) })) || [];

    const categories =
      menus
        ?.find((item) => item.id === menu?.id)
        ?.categories?.filter((item) => String(item.section_id) === section?.id)
        ?.map((item) => ({ id: String(item.id), value: getLocale(item.name) })) || [];

    return {
      menus: menus?.map((item) => ({ id: item.id, value: getLocale(item.name) })) || [],
      sections,
      categories,
    };
  }, [section, menuList]);

  const handleCopy = async () => {
    const isValid = validate({
      menu: { rule: () => !!menu?.id },
      section: { rule: () => !!section?.id },
      category: { rule: () => !!category?.id },
    });

    if (!isValid || !menu || !section || !category) return;

    copyDish({ dishId, target_category_id: category?.id, target_section_id: section?.id }).then(
      props.onClose,
    );
  };

  const handleSelectMenu = (item: IdValue) => {
    fetchMenu(item.id);
    setMenu(item);
    setSection(undefined);
    setCategory(undefined);
  };

  const handleSelectSection = (item: IdValue) => {
    setSection(item);
    setCategory(undefined);
  };

  return {
    t,
    sections,
    isLoading,
    getLocale,
    categories,
    section,
    handleSelectSection,
    category,
    setCategory,
    menus,
    menu,
    handleSelectMenu,
    handleCopy,
  };
};
